import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Contact from './views/Contact.vue'
import Giveaway from './views/Giveaway.vue'
import Giveaway2 from './views/Giveaway2.vue'
import Details from './views/Details.vue'
import DailyDeals from './views/DailyDeals.vue'
import Blog from './views/Blog.vue'
import Article from './views/Article.vue'
import PrivacyPolicy from './views/PrivacyPolicy.vue'
import Backend from './views/Backend.vue'
import Analytics from './views/Analytics.vue'
import Analysis from './views/Analysis.vue'
import DealSearch from './views/DealSearch.vue'
import Landing from './views/Landing.vue'
import StartShopping from './views/StartShopping.vue'
import DealNumber from './views/DealNumber.vue'
import DealShare from './views/DealShare.vue'
import GiftCenter from './views/GiftCenter.vue'
import GiftIdeas from './views/GiftIdeas.vue'
import GiftListManager from './views/GiftListManager.vue'

import settings from './settings'
import ga from '@/helpers/ga'
import clicky from '@/helpers/clicky'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/about',
            name: 'about',
            component: About
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact
        },
        {
            path: '/giveaway',
            name: 'giveaway',
            component: Giveaway2
        },
        {
            path: '/deal/:id',
            name: 'deal',
            component: Details
        },
        {
            path: '/daily-deals/:date',
            name: 'dailydeals',
            component: DailyDeals
        },
        {
            path: '/deal/:id/:title',
            name: 'deal2',
            component: Details
        },
        {
            path: '/blog',
            name: 'blog',
            component: Blog
        },
        {
            path: '/blog/:id',
            name: 'article',
            component: Article
        },
        {
            path: '/blog/:id/:title',
            name: 'article2',
            component: Article
        },
        {
            path: '/privacy-policy',
            name: 'privacy',
            component: PrivacyPolicy
        },
        {
            path: '/backend',
            name: 'backend',
            component: Backend
        },
        {
            path: '/analytics',
            name: 'analytics',
            component: Analytics
        },
        {
            path: '/analysis',
            name: 'analysis',
            component: Analysis
        },
        {
            path: '/deal-search',
            name: 'dealsearch',
            component: DealSearch
        },
        //{
        //    path: '/miami-moms',
        //    name: 'mom',
        //    component: () => import(/* webpackChunkName: "blog" */ './views/Mom.vue')
        //},
        {
            path: '/p/:landing',
            name: 'landing',
            component: Landing
        },
        {
            path: '/shopping/:id',
            name: 'startShopping',
            component: StartShopping
        },
        {
            path: '/dealnumber',
            name: 'dealnumber',
            component: DealNumber
        },
        {
            path: '/dealshare',
            name: 'dealshare',
            component: DealShare
        },
        {
            path: '/gift-list-manager',
            name: 'giftlistmanager',
            component: GiftListManager
        },
        {
            path: '/gift-ideas',
            name: 'giftideas',
            component: GiftCenter
        },
        {
            path: '/gift-ideas/:id',
            name: 'giftlist',
            component: GiftIdeas
        },
        {
            path: '/gift-ideas/:id/:title',
            name: 'giftlist2',
            component: GiftIdeas
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        // page scroll to top for all route navigations
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
});

router.beforeEach((to, from, next) => {
    next();
});

router.afterEach((to, from) => {
    ga.config(settings.googleTagId, { page_path: to.path, send_page_view: true });

    if (window._gauges && from && from.name) {
        window._gauges.push(['track']);
    }

    //clicky.log(document.title, 'pageview');

});

export default router;